import * as React from 'react';
import { observer } from 'mobx-react';
import { computed, observable } from 'mobx';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react';
import { ContractType, ContractTypeModel } from '@app/Models';

type OnChangeHandler = (type: ContractTypeModel) => void;

type ContractTypeModelDropdownProps = {
    onChange: OnChangeHandler;
    typeModel?: ContractTypeModel;
    type: ContractType;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    isCabin: boolean;
    isCombinedContractTypeModel?: boolean;
};

@observer
export class ContractTypeModelDropdown extends React.Component<ContractTypeModelDropdownProps, {}> {
    private _store: ContractTypeModelDropdownStore;

    constructor(props: ContractTypeModelDropdownProps) {
        super(props);
        this._store = new ContractTypeModelDropdownStore(props);
    }

    componentDidUpdate(prevProps: ContractTypeModelDropdownProps) {
        this._store.type = this.props.type;
        if (prevProps.isCabin !== this.props.isCabin) {
            this._store.isCabin = this.props.isCabin;
        }
    }

    render() {
        return (
            <Dropdown
                label="Contract Model"
                options={this._store.contractSubTypeOptions}
                onChange={this._store.onChangeTypeModel}
                required={this.props.required}
                selectedKey={this.props.typeModel as string}
                className={this.props.className}
                disabled={this.props.disabled}
            />
        );
    }

}

class ContractTypeModelDropdownStore {
    private readonly _onChange: OnChangeHandler;

    @observable type: ContractType = ContractType.None;
    @observable isCabin: boolean;
    @observable isCombinedContractTypeModel?: boolean;

    constructor(props: ContractTypeModelDropdownProps) {
        this.type = props.type;
        this.isCabin = props.isCabin;
        this.isCombinedContractTypeModel = props.isCombinedContractTypeModel;
        this._onChange = props.onChange;
    }

    onChangeTypeModel = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChange(option.key as ContractTypeModel);
        }
    };

    @computed
    get contractSubTypeOptions() {
        const typeIndex = this.type;
        let keys = [];
        if (typeIndex === ContractType.Tzv) {
            keys.push({ key: ContractTypeModel.TZV_Ground, text: ContractTypeModel.TZV_Ground });
            keys.push({ key: ContractTypeModel.TZV_Month, text: ContractTypeModel.TZV_Month });
            keys.push({ key: ContractTypeModel.TZV_Day, text: ContractTypeModel.TZV_Day });
            keys.push({ key: ContractTypeModel.TZV_VariableBlock, text: ContractTypeModel.TZV_VariableBlock });
            keys.push({ key: ContractTypeModel.TZV_VariableDay, text: ContractTypeModel.TZV_VariableDay });
            keys.push({ key: ContractTypeModel.TZV_FixBlock, text: ContractTypeModel.TZV_FixBlock });
            keys.push({ key: ContractTypeModel.TZV_FixDay, text: ContractTypeModel.TZV_FixDay });
            keys.push({ key: ContractTypeModel.TZV_Spez, text: ContractTypeModel.TZV_Spez });
            if (!this.isCabin) {
                keys.push({ key: ContractTypeModel.TZV_FixDay_Sh, text: ContractTypeModel.TZV_FixDay_Sh });
                keys.push({ key: ContractTypeModel.TZV_FixDay_Mff, text: ContractTypeModel.TZV_FixDay_Mff });
                keys.push({ key: ContractTypeModel.TZV_VariableDay_LhSff, text: ContractTypeModel.TZV_VariableDay_LhSff });
                if (!this.isCombinedContractTypeModel) {
                    keys.push({ key: ContractTypeModel.TZV_R, text: ContractTypeModel.TZV_R });
                }
            }
        } else if (typeIndex === ContractType.Freelance) {
            keys.push({ key: ContractTypeModel.None, text: ContractTypeModel.None });
            keys.push({ key: ContractTypeModel.FL_A, text: ContractTypeModel.FL_A });
            keys.push({ key: ContractTypeModel.FL_B, text: ContractTypeModel.FL_B });
            keys.push({ key: ContractTypeModel.FL_C, text: ContractTypeModel.FL_C });
            keys.push({ key: ContractTypeModel.FL_S, text: ContractTypeModel.FL_S });
        } else {
            keys.push({ key: ContractTypeModel.None, text: ContractTypeModel.None });
        }
        return keys;
    }
}